(function () {
  var urlParam    = 'sp';
  var storageKey  = 'dx';
  var cookieDays  = 30;
  var readyClass  = 'dx-ready';
  var retries     = 0;
  var maxRetries  = 6;
  var validValues = ['1', '2', '3', '4']; // add more values here if you add more variants

  var variants = {
    '1': {
      toggles: {
        heading:      true,
        subheading:   true,
        ratingCaption:true,
        bodyText:     true,
        reviews:      true,
        accordion:    false,
        imageSlide1:  false,
        imageThumb1:  false,
        imageSlide2:  false,
        imageThumb2:  false,
        imageSlide3:  false,
        imageThumb3:  false
      },
      copy: {
        heading:       'brain food',
        subheading:    'reclaim your clarity',
        ratingCaption: '4.7 rated by 791 customers',
        text:          'Feel clearer and settle into steadier focus.<br><br>A daily blend of 16 nutrients and botanicals to support clearer thinking and steady energy.',
        reviews: [
  { reviewer: 'Vicki T. (35-44)', date: '9th May 2025', stars: 5, text: '"My brain fog has lifted and I am just able to function as a human again... I just feel like I\'m not wading through mud anymore."' },
  { reviewer: 'Sarah G. (45-54)', date: '13th Jul 2025', stars: 5, text: '"get dopa has helped me get from head in hands task paralysis, to far less overwhelm and being able to tackle jobs one at a time."' },
  { reviewer: 'Adelle R. (35-44)', date: '5th Sep 2024', stars: 5, text: '"I\'m finding it easier to do all those little tasks that stack up into a big pile of overwhelm (for example: I put clean laundry away, straight away, where it belongs, not on a random chair to rot for a month!)"' },
  { reviewer: 'Fleur B. (44-54)', date: '1st Sep 2025', stars: 5, text: '"Oh my goodness me - I\'ve been taking get dopa for a few weeks and it\'s made a noticeable difference. During perimenopause I\'d been struggling with brain fog, overwhelm and fluctuating moods. Now I feel calmer, clearer and much more able to get through the day."' },
  { reviewer: 'Emma N. (25-34)', date: '9th Jul 2025', stars: 5, text: '"Despite taking it at the most challenging part of my life so far (full house renovation while working 12 hour shifts) I have seen a difference. My mood has remained remarkably stable and overwhelm has been manageable."' }
],
        accordion: {
          matchHeading: "for brains that don’t switch off",
          newHeading:   'your variant 1 accordion heading',
          newContent:   '<p>Your variant 1 accordion content goes here.</p>'
        },
        images: {
          slide1: { src: 'https://cdn.shopify.com/s/files/your-main-persona-image.jpg',    alt: 'Persona image 1' },
          thumb1: { src: 'https://cdn.shopify.com/s/files/your-thumb-persona-image.jpg',   alt: 'Persona image 1 thumbnail' },
          slide2: { src: 'https://cdn.shopify.com/s/files/your-main-persona-image-2.jpg',  alt: 'Persona image 2' },
          thumb2: { src: 'https://cdn.shopify.com/s/files/your-thumb-persona-image-2.jpg', alt: 'Persona image 2 thumbnail' },
          slide3: { src: 'https://assistppc.com/assets/assistppc-logo.svg',                alt: 'Persona image 3' },
          thumb3: { src: 'https://assistppc.com/assets/assistppc-logo.svg',                alt: 'Persona image 3 thumbnail' }
        }
      }
    },

    '2': {
      toggles: {
        heading:      false,
        subheading:   false,
        ratingCaption:true,
        bodyText:     false,
        reviews:      true,
        accordion:    false,
        imageSlide1:  false,
        imageThumb1:  false,
        imageSlide2:  false,
        imageThumb2:  false,
        imageSlide3:  false,
        imageThumb3:  false
      },
      copy: {
        heading:       'your variant 2 heading',
        subheading:    '',
        ratingCaption: '4.7 rated by 791 busy brains',
        text:          'Variant 2 body text goes here.',
        reviews: [
  { reviewer: 'Diana H. (45-54)', date: '11th Apr 2026', stars: 5, text: '"I am really impressed with get dopa; my focus, concentration and sleep have all improved noticeably. Best of all, it has calmed down the awful restlessness and agitation that the H in **** causes me."' },
  { reviewer: 'Ciara J. (35-44)', date: '29th Sep 2025', stars: 5, text: '"It feels like the noise in my brain is finally quiet enough to actually get stuff done."' },
  { reviewer: 'Rhiannon K. (25-34)', date: '14th Apr 2025', stars: 5, text: '"I certainly find my challenges with **** more manageable now... having brain fog less often and feeling more in control, I am able to self regulate easier."' },
  { reviewer: 'Julie H. (45-54)', date: '3rd Aug 2025', stars: 5, text: '"I have **** and I was suffering burnout. I wasn\'t eating well and my sleep was poor. I was recommended get dopa by a nutritionist as a good quality supplement that would help me get my body back into balance. I\'m on my third month now and feel ten times better already."' },
  { reviewer: 'Sabrina P. (25-34)', date: '17th Apr 2025', stars: 5, text: '"I\'ve struggled for a long time with keeping my brain focussed. get dopa has been a game changer. For the first time I\'ve felt like my mind was calmer and quieter, and given me the break I needed to take the next steps to keeping my **** in check."' }
],
        accordion: {
          matchHeading: "what to expect",
          newHeading:   'your variant 2 accordion heading',
          newContent:   '<p>Your variant 2 accordion content goes here.</p>'
        },
        images: {
          slide1: { src: 'https://cdn.shopify.com/s/files/variant-2-slide-1.jpg', alt: 'Variant 2 image 1' },
          thumb1: { src: 'https://cdn.shopify.com/s/files/variant-2-thumb-1.jpg', alt: 'Variant 2 image 1 thumbnail' },
          slide2: { src: '', alt: '' },
          thumb2: { src: '', alt: '' },
          slide3: { src: '', alt: '' },
          thumb3: { src: '', alt: '' }
        }
      }
    },

    '3': {
      toggles: {
        heading:      true,
        subheading:   true,
        ratingCaption:true,
        bodyText:     true,
        reviews:      true,
        accordion:    true,
        imageSlide1:  false,
        imageThumb1:  false,
        imageSlide2:  false,
        imageThumb2:  false,
        imageSlide3:  false,
        imageThumb3:  false
      },
      copy: {
        heading:       'brain food',
        subheading:    'reclaim your clarity',
        ratingCaption: '4.7 rated by 791 customers',
        text:          'Feel clearer and settle into steadier focus.<br><br>A daily blend of 16 nutrients and botanicals to support clearer thinking and steady energy.',
       reviews: [
  { reviewer: 'Fleur B. (44-54)', date: '1st Sep 2025', stars: 5, text: '"Oh my goodness me - I\'ve been taking get dopa for a few weeks and it\'s made a noticeable difference. During perimenopause I\'d been struggling with brain fog, overwhelm and fluctuating moods. Now I feel calmer, clearer and much more able to get through the day."' },
  { reviewer: 'Louise B. (44-54)', date: '13th Dec 2025', stars: 5, text: '"My menopausal brain refuses to work these days. Get Dopa helps my brain work. I was so sceptical until I came off them for a few weeks and noticed a massive difference — the brain fog came back. They work, they\'re fab."' },
  { reviewer: 'Vicki T. (35-44)', date: '9th May 2025', stars: 5, text: '"My brain fog has lifted and I am just able to function as a human again... I just feel like I\'m not wading through mud anymore."' },
  { reviewer: 'Sarah K. (45-54)', date: '19th Nov 2025', stars: 5, text: '"I\'ve tried so many supplements over the years and get dopa is the one product that actually works for me. Three capsules in the morning and I\'m able to function efficiently — almost as if I don\'t have a busy brain and perimenopause symptoms. I highly recommend."' },
  { reviewer: 'Amy H. (35-44)', date: '5th May 2025', stars: 5, text: '"I noticed an immediate difference from day 1. More clarity, focus and mental calm, without any jitters or feeling wired. I also had knock-on benefits of dramatically reduced PMS struggles like low mood, energy slumps and brain fog — which was a huge win."' }
],
        accordion: {
          matchHeading: "for brains that don’t switch off",
          newHeading:   "when your brain doesn’t feel like yours",
          newContent:   '<p>There are times when your brain just doesn\'t feel like yours — more overwhelm, harder to focus, harder to stay on top of things.</p><p>get dopa is a daily blend of 16 nutrients and botanicals to support focus, energy and mental clarity — all in one easy morning supplement.</p><p>Read what our customers say and see how get dopa fits into your day.</p>'
        },
        images: {
          slide1: { src: '', alt: '' },
          thumb1: { src: '', alt: '' },
          slide2: { src: 'https://cdn.shopify.com/s/files/1/0669/6897/7720/files/Product_Page_Image_1_Image_2.png?v=1771593304', alt: 'Variant 3 image 2' },
          thumb2: { src: 'https://cdn.shopify.com/s/files/1/0669/6897/7720/files/Product_Page_Image_1_Image_2.png?v=1771593304', alt: 'Variant 3 image 2 thumbnail' },
          slide3: { src: '', alt: '' },
          thumb3: { src: '', alt: '' }
        }
      }
    },
'4': {
      toggles: {
        heading:      true,
        subheading:   true,
        ratingCaption:true,
        bodyText:     true,
        reviews:      true,
        accordion:    true,
        imageSlide1:  false,
        imageThumb1:  false,
        imageSlide2:  false,
        imageThumb2:  false,
        imageSlide3:  false,
        imageThumb3:  false
      },
      copy: {
        heading:       'brain food',
        subheading:    'reclaim your balance',
        ratingCaption: '4.7 rated by 791 customers',
        text:          'Feel more balanced and settled throughout the month.<br><br>A daily blend of 16 nutrients and botanicals to support mood, focus and steady energy.',
 reviews: [
      { reviewer: 'Emma L. (25-34)',  date: '4th Aug 2025',    stars: 5, text: '"Nearly two years in and the difference in my mood is undeniable. I feel a lot more balanced and less \'up and down\'. It helps me stay more in control of my emotions, focus and motivation - and it really helps with what I go through each month, which is a massive bonus. Even after a week I felt brighter."' },
      { reviewer: 'Zoe S. (35-44)',   date: '10th Sep 2024',   stars: 5, text: '"I had a 4-day break due to ordering issues, and I noticed I was very unstable - my mood and mind became very erratic. I\'m not sure if this was my hormones or not being on this supplement, but I was happy knowing I had them when they arrived."' },
      { reviewer: 'Amy H. (35-44)',   date: '5th Mar 2025',    stars: 5, text: '"I noticed an immediate difference from day 1. More clarity, focus and mental calm, without any jitters or feeling wired. I also had knock-on benefits of dramatically reduced that time of the month - low mood, energy slumps and brain fog - which was a huge win."' },
      { reviewer: 'Jodie B. (25-34)', date: '14th Aug 2024',   stars: 5, text: '"For the first time in my adult life I feel able to trust that my mood and energy will be generally consistent (aside from cycle fluctuations), and the payoff has been huge. Finally, I\'ve been able to harness the positives, without suffering the fallout of burnout and crashing energy."' },
      { reviewer: 'Lucy S. (25-34)',  date: '17th Apr 2025',   stars: 5, text: '"Get Dopa has changed my life! I\'ve struggled with **** and **** for years and it\'s hugely impacted my life. I saw Get Dopa online and thought okay let\'s try this, I\'m sure it won\'t work but WOW! The change was so fast - 2+ months in and I will not be without this ever again."' }
    ],
        accordion: {
          matchHeading: "for brains that don’t switch off",
          newHeading:   "when your brain doesn’t feel like yours",
          newContent:   '<p>There are times when your brain just doesn\'t feel like yours — harder to focus, harder to stay even, harder to feel like yourself.</p><p>get dopa is a daily blend of 16 nutrients and botanicals to support mood, focus and mental clarity — all in one easy morning supplement.</p><p>Read what our customers say and see how get dopa fits into your day.</p>'
        },
        images: {
          slide1: { src: '', alt: '' },
          thumb1: { src: '', alt: '' },
          slide2: { src: 'https://cdn.shopify.com/s/files/1/0669/6897/7720/files/Product_Page_Image_1_Image_2.png?v=1771593304', alt: 'Variant 3 image 2' },
          thumb2: { src: 'https://cdn.shopify.com/s/files/1/0669/6897/7720/files/Product_Page_Image_1_Image_2.png?v=1771593304', alt: 'Variant 3 image 2 thumbnail' },
          slide3: { src: '', alt: '' },
          thumb3: { src: '', alt: '' }
        }
      }
    }
  };

  // ─────────────────────────────────────────────────────────────
  // HELPERS
  // ─────────────────────────────────────────────────────────────
  function setCookie(name, value, days) {
    var maxAge = days * 24 * 60 * 60;
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
  }

  function getCookie(name) {
    var escapedName = name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1');
    var match = document.cookie.match(new RegExp('(?:^|; )' + escapedName + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setStoredValue(value) {
    try { localStorage.setItem(storageKey, value); } catch (e) {}
    setCookie(storageKey, value, cookieDays);
  }

  function getStoredValue() {
    try {
      var localValue = localStorage.getItem(storageKey);
      if (localValue) return localValue;
    } catch (e) {}
    return getCookie(storageKey);
  }

  function getParamValue(param) {
    return new URL(window.location.href).searchParams.get(param);
  }

  function swapImageInContainer(selector, newSrc, newAlt) {
    if (!newSrc) return false;
    var container = document.querySelector(selector);
    if (!container) return false;
    var img = container.querySelector('img');
    if (!img) return false;
    img.src    = newSrc;
    img.srcset = newSrc;
    if (newAlt) img.alt = newAlt;
    return true;
  }

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getPersonaCustomerProofEl() {
    return document.querySelector('[data-persona-customer-proof]');
  }

  function getTrustpilotLogoUrl() {
    var el = getPersonaCustomerProofEl();
    return el && el.dataset ? el.dataset.trustpilotLogoUrl || '' : '';
  }

  function getReviewsIoLogoUrl() {
    var el = getPersonaCustomerProofEl();
    return el && el.dataset ? el.dataset.reviewsIoLogoUrl || '' : '';
  }

  function trustpilotBadgeHtml() {
    var url = getTrustpilotLogoUrl();
    if (!url) return '';
    return (
      '<div class="campaign-pdp-customer-proof__platform-svg campaign-pdp-customer-proof__platform-svg--trustpilot" aria-hidden="true">' +
      '<img class="campaign-pdp-customer-proof__platform-img" src="' +
      escapeHtml(url) +
      '" width="112" alt="" loading="lazy" style="width:112px;height:auto;max-height:112px;object-fit:contain">' +
      '</div>'
    );
  }

  function reviewsIoBadgeHtml() {
    var url = getReviewsIoLogoUrl();
    if (!url) return '';
    return (
      '<div class="campaign-pdp-customer-proof__platform-svg campaign-pdp-customer-proof__platform-svg--reviews-io" aria-hidden="true">' +
      '<img class="campaign-pdp-customer-proof__platform-img" src="' +
      escapeHtml(url) +
      '" width="112" height="20" alt="" loading="lazy">' +
      '</div>'
    );
  }

  // ─────────────────────────────────────────────────────────────
  // APPLY
  // ─────────────────────────────────────────────────────────────
  function applyPersona() {
    var activeValue = getStoredValue();

    if (!activeValue || !variants[activeValue]) return false;

    var cfg     = variants[activeValue];
    var toggles = cfg.toggles;
    var copy    = cfg.copy;
    var applied = false;

    if (toggles.heading) {
      document.querySelectorAll('[data-dx-heading]').forEach(function (el) {
        el.textContent = copy.heading;
        applied = true;
      });
    }

    if (toggles.subheading) {
      document.querySelectorAll('[data-dx-subheading]').forEach(function (el) {
        el.textContent = copy.subheading;
        applied = true;
      });
    }

    if (toggles.ratingCaption) {
      document.querySelectorAll('.rating-text-caption').forEach(function (el) {
        el.textContent = copy.ratingCaption;
        applied = true;
      });
    }

    if (toggles.bodyText) {
      document.querySelectorAll('[data-dx-text]').forEach(function (el) {
        el.innerHTML = '<p>' + copy.text + '</p>';
        applied = true;
      });
    }

    if (toggles.accordion && copy.accordion) {
      document.querySelectorAll('.product__accordion').forEach(function (accordion) {
        var headingEl = accordion.querySelector('.collapsible_tab__title');
        var contentEl = accordion.querySelector('.accordion__content');
        if (!headingEl || !contentEl) return;
        if (headingEl.textContent.trim().toLowerCase() === copy.accordion.matchHeading.toLowerCase()) {
          headingEl.textContent = copy.accordion.newHeading;
          contentEl.innerHTML   = copy.accordion.newContent;
          applied = true;
        }
      });
    }

    // ── REVIEWS ────────────────────────────────────────────────
    var existingCard = document.querySelector(
      '[data-dx-reviews]:not([data-persona-customer-proof]) .custom-reviews-carousel__card'
    );
    var starTemplate = existingCard
      ? existingCard.querySelector('.custom-reviews-carousel__stars').innerHTML
      : '';
    var arrowTemplate = existingCard
      ? existingCard.querySelector('.pdp-trust-review-card__next').innerHTML
      : '';

    var tickTemplate = '';
    if (existingCard) {
      var reviewerDiv = existingCard.querySelector('.pdp-trust-review-card__reviewer');
      if (reviewerDiv) {
        var clone = reviewerDiv.cloneNode(true);
        var nameSpan = clone.querySelector('span');
        if (nameSpan) clone.removeChild(nameSpan);
        tickTemplate = clone.innerHTML.trim();
      }
    }

    var proofStarsEl = document.querySelector(
      '[data-persona-customer-proof] .campaign-pdp-customer-proof__stars'
    );
    var proofStarTemplate = proofStarsEl ? proofStarsEl.innerHTML : '';

    function buildStars() {
      return '<div class="custom-reviews-carousel__stars">' + starTemplate + '</div>';
    }

    function buildCard(review) {
      return (
        '<div class="custom-reviews-carousel__card">' +
        '<div class="pdp-trust-review-card__top">' +
        '<div class="pdp-trust-review-card__reviewer">' +
        '<span>' +
        review.reviewer +
        '</span>' +
        tickTemplate +
        '</div>' +
        '<div class="pdp-trust-review-card__date">' +
        review.date +
        '</div>' +
        '</div>' +
        '<div class="custom-reviews-carousel__review">' +
        '<p class="custom-reviews-carousel__review-text">' +
        review.text +
        '</p>' +
        '</div>' +
        '<div class="pdp-trust-review-card__footer">' +
        buildStars() +
        '<button type="button" class="pdp-trust-review-card__next" aria-label="Next review">' +
        arrowTemplate +
        '</button>' +
        '</div>' +
        '</div>'
      );
    }

    function buildCampaignCustomerProofCard(review, starsInner) {
      var headline = review.headline != null ? String(review.headline) : '';
      var body =
        review.body != null && String(review.body) !== ''
          ? String(review.body)
          : String(review.text || '');
      var author = escapeHtml(review.reviewer || '');
      var platform = review.platform || 'reviews_io';
      var platformHtml = '';
      if (platform === 'trustpilot') {
        var tp = trustpilotBadgeHtml();
        if (tp) {
          platformHtml =
            '<div class="campaign-pdp-customer-proof__platform-badge">' + tp + '</div>';
        }
      } else if (platform === 'reviews_io') {
        var rio = reviewsIoBadgeHtml();
        if (rio) {
          platformHtml =
            '<div class="campaign-pdp-customer-proof__platform-badge">' + rio + '</div>';
        }
      }
      var photoBlock = '';
      if (review.photo) {
        photoBlock =
          '<div class="campaign-pdp-customer-proof__photo-wrap"><img class="campaign-pdp-customer-proof__photo" src="' +
          escapeHtml(review.photo) +
          '" alt="" loading="lazy" width="250" height="250"></div>';
      }
      var starsBlock =
        '<div class="campaign-pdp-customer-proof__stars">' +
        (starsInner || '') +
        '</div>';
      return (
        '<div class="campaign-pdp-customer-proof__slide">' +
        '<article class="campaign-pdp-customer-proof__card">' +
        photoBlock +
        '<div class="campaign-pdp-customer-proof__quotes">' +
        (headline
          ? '<p class="campaign-pdp-customer-proof__headline">' + escapeHtml(headline) + '</p>'
          : '') +
        (body
          ? '<p class="campaign-pdp-customer-proof__body">' + escapeHtml(body) + '</p>'
          : '') +
        '</div>' +
        starsBlock +
        '<div class="campaign-pdp-customer-proof__meta">' +
        (author ? '<p class="campaign-pdp-customer-proof__author">' + author + '</p>' : '') +
        platformHtml +
        '</div>' +
        '</article>' +
        '</div>'
      );
    }
    

    if (toggles.reviews && copy.reviews && copy.reviews.length) {
      // Only replace reviews in the top smaller carousel.
      // Skip the bottom customer-proof carousel so its photos and layout stay intact.
      document
        .querySelectorAll('[data-dx-reviews]:not([data-persona-customer-proof])')
        .forEach(function (carousel) {
          var owl = carousel.querySelector('.owl-carousel');
          if (!owl) return;
          if (owl.classList.contains('owl-loaded') && typeof jQuery !== 'undefined') {
            jQuery(owl).trigger('destroy.owl.carousel');
            owl.classList.remove('owl-loaded');
          }
          owl.innerHTML = copy.reviews.map(buildCard).join('');
          try {
            owl.dispatchEvent(new CustomEvent('dx-persona-reviews-injected', { bubbles: true }));
          } catch (e3) {}
          applied = true;
        });
    }

    // ── IMAGES ─────────────────────────────────────────────────
    var imageMap = [
      ['imageSlide1', '[data-dx-slide="1"]', copy.images.slide1],
      ['imageThumb1', '[data-dx-thumb="1"]', copy.images.thumb1],
      ['imageSlide2', '[data-dx-slide="2"]', copy.images.slide2],
      ['imageThumb2', '[data-dx-thumb="2"]', copy.images.thumb2],
      ['imageSlide3', '[data-dx-slide="3"]', copy.images.slide3],
      ['imageThumb3', '[data-dx-thumb="3"]', copy.images.thumb3]
    ];

    imageMap.forEach(function (entry) {
      var toggleKey = entry[0];
      var selector  = entry[1];
      var imgCopy   = entry[2];
      if (toggles[toggleKey] && swapImageInContainer(selector, imgCopy.src, imgCopy.alt)) {
        applied = true;
      }
    });

    document.documentElement.setAttribute('data-dx', activeValue);
    if (applied) document.documentElement.classList.add(readyClass);

    return applied;
  }

  function runPersona() {
    var applied = applyPersona();
    if (!applied && retries < maxRetries) {
      retries++;
      setTimeout(runPersona, 150);
    }
  }

  // ─────────────────────────────────────────────────────────────
  // INIT
  // ─────────────────────────────────────────────────────────────
  var paramValue = getParamValue(urlParam);

  if (paramValue && validValues.indexOf(paramValue) !== -1) {
    setStoredValue(paramValue);
    document.documentElement.classList.add('dx-active');
  }

  if (validValues.indexOf(getStoredValue()) !== -1) {
    document.documentElement.classList.add('dx-active');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runPersona);
  } else {
    runPersona();
  }
})();